module.exports = __webpack_public_path__ + "static/media/Lindsay Hunter.4afc7870.png";